import React from "react";

const STATUS_CONFIG = {
  completed: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500", label: "Completed" },
  running:   { bg: "bg-blue-50",    text: "text-blue-700",    dot: "bg-blue-500",    label: "Running" },
  failed:    { bg: "bg-red-50",     text: "text-red-700",     dot: "bg-red-500",     label: "Failed" },
  pending:   { bg: "bg-amber-50",   text: "text-amber-700",   dot: "bg-amber-500",   label: "Pending" },
};

const StatusBadge = ({ status, config }) => {
  const mergedConfig = { ...STATUS_CONFIG, ...config };
  const cfg = mergedConfig[status] || mergedConfig.pending;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${cfg.bg} ${cfg.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
};

export { STATUS_CONFIG };
export default StatusBadge;
